import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { DateUtilsService, TranslationService } from '@sdbn/common';
import { Transport, TransportReceiver } from '../../../../common/model/transport.model';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-pickup-truck-field',
  templateUrl: './pickup-truck-field.component.html',
  styleUrls: ['./pickup-truck-field.component.scss']
})
export class PickupTruckFieldComponent implements OnInit, TransportReceiver {

  transport: Transport;

  active: boolean = false;

  formGroup = new FormGroup({
    pickupTruckEnabled: new FormControl(false, []),
    numberplate: new FormControl(null, []),
    date: new FormControl(new Date(), [])
  });

  constructor(
    public translationService: TranslationService,
    private dateUtilsService: DateUtilsService
  ) {
  }

  changing = false;

  ngOnInit(): void {
    this.formGroup.valueChanges.subscribe(value => {

      if (this.changing) {
        return;
      }

      let changed = !this.transport.masterdata.pickupTruckEnabled && value.pickupTruckEnabled;

      this.transport.masterdata.pickupTruckEnabled = value.pickupTruckEnabled;
      this.transport.masterdata.pickupTruckNumberPlate = value.pickupTruckEnabled ? value.numberplate : null;
      this.transport.masterdata.pickupTruckTime = value.pickupTruckEnabled ? this.dateUtilsService.formatDateStringToTimestamp(value.date) : null;

      if (changed && this.transport.masterdata.pickupTruckTime == null) {
        this.changing = true;
        this.transport.masterdata.pickupTruckTime = DateTime.fromJSDate(new Date()).toFormat("yyyyMMddHHmm00");
        this.formGroup.patchValue({
          pickupTruckEnabled: this.transport.masterdata.pickupTruckEnabled,
          numberplate: this.transport.masterdata.pickupTruckNumberPlate,
          date: this.dateUtilsService.formatTimestampToDateString(this.transport.masterdata.pickupTruckTime)
        });
        this.changing = false;
      }

    });
  }

  public setTransport(value: Transport) {
    this.transport = value;
    this.formGroup.patchValue({
      pickupTruckEnabled: this.transport.masterdata.pickupTruckEnabled,
      numberplate: this.transport.masterdata.pickupTruckNumberPlate,
      date: this.dateUtilsService.formatTimestampToDateString(this.transport.masterdata.pickupTruckTime)
    });
  }

  // // später in zentralen Service verschieben
  // private toDateString(value: string): string {
  //   if (value == null) {
  //     return null;
  //   }
  //   return value.substring(0, 4) + '-' + value.substring(4, 6) + '-' + value.substring(6, 8) + 'T' + value.substring(8, 10) + ':' + value.substring(10, 12)+'00';
  // }

  // private fromDateString(value: string): string {
  //   if (value == null) {
  //     return null;
  //   }
  //   return value.substring(0, 4) + value.substring(5, 7) + value.substring(8, 10) + value.substring(11, 13) + value.substring(14, 16)+'00';
  // }

}
